var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"city-footer"},[_c('h4',{attrs:{"data-anim":"title"}},[_vm._v("next stop")]),_vm._v(" "),_c('router-link',{attrs:{"to":_vm.cityfooter.urlNext}},[_c('CityFooterImage',{attrs:{"data":_vm.cityfooter}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fdfa876","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CityFooter.vue
// module id = 595
// module chunks = 3